<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Autisti </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_calendario_generico = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-calendar </v-icon>
          </v-btn>
        </template>
        <span>Vedi calendario generico</span>
      </v-tooltip>
      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="creaCalendario"
            small
            v-bind="attrs"
            v-on="on"
            class="ml-5"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Crea calendario schedulazione</span>
      </v-tooltip>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-row align="center" justify="center">
      <v-col cols="4">
        <v-autocomplete
          background-color="#ffffff"
          @change="filtra()"
          hide-details
          :items="lista_personale"
          :item-text="(e) => e.cognome"
          item-value="id_conduttore"
          label="Cognome"
          style="display: inline-block; max-width: 350px"
          v-model="cognome_filtro"
        >
          <template v-slot:append>
            <v-icon
              class="ml-2"
              @click="
                cognome_filtro = null;
                filtra();
              "
              color="primary"
              >mdi-filter-off</v-icon
            >
          </template>
        </v-autocomplete>
      </v-col></v-row
    >

    <v-data-table
      height="60vh"
      style="width: 40vw; margin: auto"
      :headers="headers_personale"
      :items="lista_vista"
      :page="page_num"
      @update:page="pageChange"
      fixed-header
      :key="aggiorna"
      class="elevation-1 pt-0"
    >
      <!-- Colonna del calendario specifico -->
      <template v-slot:[`item.cal_spec`]="{ item }">
        <v-btn
          @click="
            dialog_calendario_specifico = true;
            personale_sel_id = item.id_conduttore;
            persone.push(item.id_conduttore);
          "
          small
          ><v-icon :color="item.eccezione ? 'orange' : 'primary'"
            >mdi-calendar-star</v-icon
          ></v-btn
        >
      </template>
      <!-- Colonna del calendario specifico -->
      <template v-slot:[`item.cal_gen`]="{ item }">
        <v-btn @click="generaCalendario(item)" small
          ><v-icon :color="item.disponibilita ? 'primary' : 'orange'"
            >mdi-calendar-plus</v-icon
          ></v-btn
        >
      </template>
    </v-data-table>
    <!-- DIALOG CALENDARIO GENERICO -->
    <v-dialog v-model="dialog_calendario_generico" max-width="600px">
      <CalendarioGenerico
        @click_chiudi="
          dialog_calendario_generico = false;
          pageSet();
        "
        :bottoni="true"
      />
    </v-dialog>
    <!-- DIALOG CALENDARIO SPECIFICO -->
    <v-dialog v-model="dialog_calendario_specifico" max-width="800px">
      <CalendarioSpecifico
        @click_chiudi="
          dialog_calendario_specifico = false;
          getEccezioniLista();
          pageSet();
        "
        :id_riferimento="personale_sel_id"
        :tipo="4"
      />
    </v-dialog>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
  
  <script>
import CalendarioGenerico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioGenerico.vue";
import CalendarioSpecifico from "@/components/PRODUCTION/Impostazioni/Calendario/CalendarioSpecifico.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "",

  components: { CalendarioGenerico, CalendarioSpecifico, SnackbarQV },

  props: ["id_conduttore"],

  data() {
    return {
      // Variabili d'appoggio
      aggiorna: 0,
      cognome_filtro: null,
      personale_sel_id: null,
      page_num: 1,
      // Modal
      dialog_calendario_generico: false,
      dialog_calendario_specifico: false,
      // Array
      headers_personale: new Array(),
      lista_personale: new Array(),
      lista_vista: new Array(),
      lista_eccezioni: new Array(),
      lista_disponibilita: new Array(),

      //Array per la creazione del calendario dello schedulatore
      persone: new Array(),
    };
  },

  computed: {},

  watch: {
    lista_personale: {
      immediate: true,
      handler() {
        this.lista_vista = this.lista_personale;
        this.filtra();
      },
    },
  },

  methods: {
    generaCalendario(item) {
      let request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "salvacalendariopersone",
          token: localStorage.getItem("user_token"),
          persone: [{ id_persona: item.id_conduttore }],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print("success", "Salvataggio Effettuato.");
            this.getPersonale();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    creaCalendario() {
      this.persone = this.persone.toString();
      console.log(this.persone);

      let request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "salvacalendariopersone",
          token: localStorage.getItem("user_token"),
          persone: this.persone,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.persone = [];
            this.$refs.SnackbarQV.print("success", "Salvataggio Effettuato.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    filtra() {
      let autisti = [];
      this.lista_personale.forEach((elem) => {
        autisti.push(elem);
      });

      // Filtro il cognome
      if (this.cognome_filtro != "" && this.cognome_filtro != null) {
        let res = [];

        autisti.forEach((elem) => {
          if (elem.id_conduttore == this.cognome_filtro) {
            res.push(elem);
          }
        });

        autisti = res;
      }

      this.lista_vista = [];
      this.lista_vista = autisti;
    },

    getPersonale() {
      this.headers_personale = [
        {
          text: "Calendario specifico",
          value: "cal_spec",
        },
        // {
        //   text: "Genera calendario",
        //   value: "cal_gen",
        // },
        {
          text: "Nome",
          value: "nome",
        },
        {
          text: "Cognome",
          value: "cognome",
        },
      ];

      let request = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "getconduttori",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store
        .dispatch("api6", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_personale = res.data.result
              ? res.data.result.filter((a) => a.validita == true)
              : [];
            this.getEccezioniLista();
            this.getDisponibilitaLista();
            this.pageSet();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })

        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },

    getEccezioniLista() {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "geteccezionilista",
          token: localStorage.getItem("user_token"),
          tipo: 4,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_eccezioni = res.data.calendario_ecc
            ? res.data.calendario_ecc
            : [];
          this.lista_personale.forEach((persona) => {
            persona.eccezione = false;
            this.lista_eccezioni.forEach((ecc) => {
              if (persona.id_conduttore == ecc.rif_calendario) {
                persona.eccezione = true;
              }
            });
          });

          this.aggiorna = this.aggiorna == 1 ? 0 : 1;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },

    getDisponibilitaLista() {
      let request = {
        controller: "Tools",
        method: "POST",
        richiesta: {
          action: "getdisponibilitapersona",
          token: localStorage.getItem("user_token"),
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.lista_disponibilita = res.data ? res.data : [];
          this.lista_personale.forEach((persona) => {
            persona.disponibilita = true;
            this.lista_disponibilita.forEach((ecc) => {
              if (persona.id_conduttore == ecc.id_persona) {
                persona.disponibilita = false;
              }
            });
          });

          this.aggiorna = this.aggiorna == 1 ? 0 : 1;
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        }
      });
    },
    pageChange(page) {
      sessionStorage.setItem("page_autistical", page);
    },

    pageSet() {
      if (sessionStorage.getItem("page_autistical"))
        this.page_num = parseInt(sessionStorage.getItem("page_autistical"));
    },
  },

  created() {},

  async mounted() {
    await this.pageChange(1);
    await this.getPersonale();
    if (this.id_conduttore) {
      this.cognome_filtro = this.id_conduttore;
      this.filtra();
    }
  },
};
</script>
  
  <style scoped>
</style>